import { GET_PROJECTS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { CREATORS_PAGE_MODULE_ID, TITLE_HEADER_MARKETPLACE_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { project } from 'root/src/shared/descriptions/endpoints/recordTypes'
import { VIEW_PROJECT_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import { cardListType } from 'root/src/shared/constants/moduleTypes'
import { marketplaceKey, activeKey } from 'root/src/shared/constants/keys'

export default {
	[CREATORS_PAGE_MODULE_ID]: {
		moduleType: 'list',
		listType: cardListType,
		listPayload: {
			currentPage: 1,
			section: marketplaceKey,
			subSection: activeKey,
		},
		recordType: project,
		endpointId: [GET_PROJECTS],
		listRouteId: VIEW_PROJECT_ROUTE_ID,
		pageItemLength: 8,
		goTopButton: true,
		sortFilterModule: TITLE_HEADER_MARKETPLACE_MODULE_ID,
	},
}
